import { useState, useEffect } from 'react';
import { FiUsers, FiClock, FiPackage, FiTrendingUp } from 'react-icons/fi';
import API_URL from '../config';

export default function Overview({ token, user }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/auth/team`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(d => setStats(d))
      .catch(() => {});
  }, [token]);

  const cards = [
    { label: 'Team Members', value: stats?.members?.length ?? '—', icon: FiUsers, color: 'blue' },
    { label: 'Clocked In Today', value: '—', icon: FiClock, color: 'green' },
    { label: 'Products', value: '—', icon: FiPackage, color: 'orange' },
    { label: 'Sales Today', value: '—', icon: FiTrendingUp, color: 'purple' },
  ];

  const colors = {
    blue:   'bg-blue-50 text-blue-600',
    green:  'bg-emerald-50 text-emerald-600',
    orange: 'bg-orange-50 text-orange-600',
    purple: 'bg-purple-50 text-purple-600',
  };

  return (
    <div className="p-4 sm:p-6">
      <h2 className="text-lg font-semibold text-slate-800 mb-4">Overview</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(c => (
          <div key={c.label} className="bg-white rounded-xl border border-slate-200 p-4">
            <div className={`w-9 h-9 rounded-lg ${colors[c.color]} flex items-center justify-center mb-3`}>
              <c.icon size={18} />
            </div>
            <p className="text-2xl font-bold text-slate-800">{c.value}</p>
            <p className="text-xs text-slate-500 mt-0.5">{c.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
